import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export function Clipboard(props: IconProps): ReactElement {
  return (
    <IconWrapper {...props}>
      <path
        d="M20.4 2.4h-5.016C14.88 1.008 13.56 0 12 0c-1.56 0-2.88 1.008-3.384 2.4H3.6c-1.32 0-2.4 1.08-2.4 2.4v16.8c0 1.32 1.08 2.4 2.4 2.4h16.8c1.32 0 2.4-1.08 2.4-2.4V4.8c0-1.32-1.08-2.4-2.4-2.4Zm-8.4 0c.66 0 1.2.54 1.2 1.2 0 .66-.54 1.2-1.2 1.2-.66 0-1.2-.54-1.2-1.2 0-.66.54-1.2 1.2-1.2Zm2.4 16.8H6v-2.4h8.4v2.4Zm3.6-4.8H6V12h12v2.4Zm0-4.8H6V7.2h12v2.4Z"
        fill="currentColor"
      />
    </IconWrapper>
  );
}
